module.exports = __webpack_public_path__ + "static/media/chess-board.0fc4865e.svg";